import {
  useMutation
} from '@tanstack/vue-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query'
import {
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  BackendErrorEntity,
  ComputeLogisticServicePriceQueryDto,
  ComputeLogisticServicePriceResponseDto
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType, BodyType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiComputeLogisticServicePrice = (
    computeLogisticServicePriceQueryDto: MaybeRef<ComputeLogisticServicePriceQueryDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      computeLogisticServicePriceQueryDto = unref(computeLogisticServicePriceQueryDto);
      
      return fetchApiInstance<ComputeLogisticServicePriceResponseDto>(
      {url: `/valueAddedServices/computeLogisticServicePrice`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: computeLogisticServicePriceQueryDto
    },
      options);
    }
  


export const getApiComputeLogisticServicePriceMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiComputeLogisticServicePrice>>, TError,{data: BodyType<ComputeLogisticServicePriceQueryDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiComputeLogisticServicePrice>>, TError,{data: BodyType<ComputeLogisticServicePriceQueryDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiComputeLogisticServicePrice>>, {data: BodyType<ComputeLogisticServicePriceQueryDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiComputeLogisticServicePrice(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiComputeLogisticServicePriceMutationResult = NonNullable<Awaited<ReturnType<typeof apiComputeLogisticServicePrice>>>
    export type ApiComputeLogisticServicePriceMutationBody = BodyType<ComputeLogisticServicePriceQueryDto>
    export type ApiComputeLogisticServicePriceMutationError = ErrorType<BackendErrorEntity>

    export const useApiComputeLogisticServicePrice = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiComputeLogisticServicePrice>>, TError,{data: BodyType<ComputeLogisticServicePriceQueryDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiComputeLogisticServicePrice>>,
        TError,
        {data: BodyType<ComputeLogisticServicePriceQueryDto>},
        TContext
      > => {

      const mutationOptions = getApiComputeLogisticServicePriceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    